import React from 'react';

const ReporterVoice = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Voice Management</h1>
      {/* Add your voice management content here */}
    </div>
  );
};

export default ReporterVoice;